import useApi from '../utils/axios-pettitions';
import { newToast } from '../components';
import { CustomFilters } from '../types/types.system';

export const useApiSearch = () => {
  const { runApi } = useApi();

  //Obtener configuración
  const SearchOrder = async (filters: CustomFilters[]) => {
    return runApi('Search/SearchOrder', 'POST', null, filters).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const SearchPatient = async (filters: CustomFilters[]) => {
    return runApi('Search/SearchPatient', 'POST', null, filters).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const GetOrderById = async (IdOrden: number) => {
    return runApi('Search/GetOrderById', 'GET', { IdOrden }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  const GetPatientById = async (IdPaciente: number) => {
    return runApi('Search/GetPatientById', 'GET', { IdPaciente }, null).then((res) => {
      if (res.internalCode >= 200) {
        newToast('ERROR', res.message, 5);
        return [];
      } else {
        return res.data;
      }
    });
  };

  return { SearchOrder, GetOrderById, SearchPatient, GetPatientById };
};
